module.exports = __webpack_public_path__ + "static/media/ifelse.afe71768.svg";